import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import withEffect from '../../../../hocs/withEffect'

import BuildLogTab from './BuildLogTab'
import {changePageFullLogBuildId, resetPageFullLog} from './BuildLogTab.actions'
import type {Props} from './BuildLogTab.types'

const actionCreators = {
  changeBuildId: changePageFullLogBuildId,
  resetState: resetPageFullLog,
}
export default compose(
  connect(null, actionCreators),
  withEffect(
    (props: Props) => props.buildId,
    props => props.changeBuildId,
    props => props.resetState,
    (buildId, changeBuildId, resetState) => {
      changeBuildId(buildId)
      return () => resetState()
    },
  ),
)(BuildLogTab)
